import "../sass/Entete.scss";
import { useEffect } from "react";
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles((theme) => ({

    small: {
        width: theme.spacing(5),
        height: theme.spacing(5),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    extraLarge: {
        width: theme.spacing(40),
        height: theme.spacing(40),
    },


}));

export default function Entete(props) {

    //Runs after render ! (useEffect runs asynchronously and after a render is painted to the screen.)
    //Rajouter des deps vides (,[]) pour que l'effet run uniquement après le 1er render
    useEffect(() => {
       
        //description = ;
        document.querySelector(".descPerso p").innerHTML = documentToHtmlString(props.infoEntete.fields.description);

    });

    const classes = useStyles();

    return (
        <section>
            <Avatar src={props.infoEntete.fields.avatar.fields.file.url} className={classes.extraLarge + " avatar"} alt="Raphael Jeudy">
            </Avatar>
            <div className="descPerso">
                <h1>Raphaël Jeudy</h1>
                <p> </p>
            </div>
        </section>

    );
}